import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../dashboard/rfq-cache.service';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  aboutDataType,
  AutoCompleteDataType,
  AutoCompleteSupplierProduct,
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SupplierService } from '../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rfq-token-quote-line-items',
  templateUrl: './quote-line-items.component.html',
  styleUrls: ['./quote-line-items.component.css'],
})
export class RfqTokenQuoteLineItemsComponent implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  isTotalsCardOpen: boolean = false;
  rfqId!: number;
  quoteId!: number;
  userId!: number;
  isSaved: boolean = false;
  currentTab: string = 'line-items';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs: any[] = [];
  currentIndex = 0;
  isFreight: boolean = false;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: 'directions_boat',
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: 'looks',
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: 'location_searching',
      route: 'payment-terms',
    },
    {
      index: 3,
      label: 'PREVIEW',
      icon: 'location_searching',
      route: 'preview',
    },
  ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  secondFormGroup!: UntypedFormGroup;
  declineFormGroup!: UntypedFormGroup;
  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData: any;
  showDeclineConfirmationDialogue: boolean = false;
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;

  // Controls editing of General Discount field and shows computed amount
  isEditingGeneralDiscount: boolean = false;
  generalDiscountAmount: number = 0;
  @ViewChildren('generalDiscountInput')
  generalDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;

  showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;
  showHazardousDeclaration: boolean = false;

  displayedColumns = [
    'position',
    'partNumber',
    'supplierPartNumber',
    'itemDescription',
    'buyerComment',
    'supplierComment',
    'customsCode',
    'uom',
    'quantity',
    'supplierUom',
    'supplierQuantity',
    'unitCost',
    'requestedUnitCost',
    'discount',
    'totalCost',
    'requestedTotalCost',
    'leadTime',
    'attachments',
    'delete',
  ];

  groupHeadersColumns = [
    'checkboxGroup',
    'positionGroup',
    'partNumberGroup',
    'supplierPartNumberGroup',
    'itemDescriptionGroup',
    'buyerCommentGroup',
    'supplierCommentGroup',
    'customsCodeGroup',
    'attachmentsGroup',
    'uomQuantityGroup',
    'supplierUomQuantityGroup',
    'unitCostGroup',
    'discountGroup',
    'totalCostGroup',
    'leadTimeGroup',
    'deleteGroup',
  ];

  lineItemAttachmentTypeData: quoteAttachmentType[] = [];
  delineReasonData: quoteDeclineReasonType[] = [];

  selectedLineItemIndex!: number | null;

  declineReason!: number | null;
  otherReason: string = '';

  freightDescription: string = '';
  freightType: string = 'amount';
  freightValue!: number | null;
  addedAdditionalCost: any[] = [];
  

  selectedAttachmentType!: number | null;
  hazardousDeclaration!: number | null;
  newfileuploaded: boolean = false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB

  exchangeRatesCache: any = {};

  currentdate = new Date();
  taxStatusData: any[] = [];

  // Tax Profile Sidebar
  showTaxSideBar: boolean = false;
  taxForm!: FormGroup;
  countryList: any[] = [];
  filteredCountryList: any[] = [];
  countryRegions: any[] = [];
  _selectedCountryCode: string = '';
  gstCertificateFile!: File;

  tableWidth = '100%';

  quoteLineItemTaxType: string | null = null;
  isFreightCost: boolean = true;

  dynamicColumns = [
    // { key: 'buyerComment', name: 'Buyer Comment', visible: false },
    // { key: 'supplierComment', name: 'Supplier Comment', visible: false },
    // { key: 'customsCode', name: 'Customs Code', visible: false },
    // { key: 'quantity', name: 'Requested Quantity', visible: false },
    // { key: 'uom', name: 'Requested UOM', visible: false },
    // { key: 'unitCost', name: 'Unit Cost', visible: false },
    // { key: 'discount', name: 'Discount', visible: false },
    // { key: 'totalCost', name: 'Total Cost', visible: false },
    // { key: 'leadTime', name: 'Lead Time', visible: false },
    // { key: 'supplierUom', name: 'Supplier UOM', visible: false },
    // { key: 'supplierQuantity', name: 'Supplier Quantity', visible: false },
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
    // { key: 'delete', name: 'Delete', visible: false },
  ];

  showColumn(col: { key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    // this.tableWidth = 'max-content';
    // this.cdr.detectChanges();
    this.table.recalculate();
  }

  showToggleColumns(col: any) {
    col.visible = !col.visible;
    this.table.recalculate();
  }

  getColumn(key: string) {
    return this.dynamicColumns.find((c) => c.key === key);
  }

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  searchKeyParams: string = '';

  boundGetSupplierProductAutoComplete!: (pageMeta: Page) => Observable<any>;

  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService: RfqGenerateFormService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private rfqTokenAuth: RfqTokenAuthService,
    private http: HttpClient
  ) {
    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });
  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    const token = this.rfqTokenAuth.getToken();
    if (!token) {
      this.fullLoaderService.hideLoader();
      this.router.navigate(['/tokenLogin']);
      return;
    }

    const storedSupplierId = this.rfqTokenAuth.getSupplierId();
    this.userId = storedSupplierId ? Number(storedSupplierId) : 0;

    this.boundGetCurrencyAutoComplete =
      this.getCurrencyFilterKeyDataObservable.bind(this);

    this.boundGetSupplierProductAutoComplete =
      this.getSupplierProductFilterKeyDataObservable.bind(this);

    this.getTaxDetails();

    // Initialize tax profile form
    this.taxForm = this._formBuilder.group({
      taxId: [null],
      nameOfTaxProfile: [null, Validators.required],
      country: [null, Validators.required],
      region: [null, Validators.required],
      regionName: [null, Validators.required],
      taxType: [],
      taxNumber: [],
      taxPercentage: [],
      gstCertificateAttachment: [],
      s3FilePath: [''],
    });

    // Load countries for tax profile sidebar
    this.loadCountryList();

    this.secondFormGroup = this._formBuilder.group({
      quoteLineItemHeaderId: [null],
      quoteLineItemListPriceSubtotal: [null],
      quoteLineItemDiscount: [null],
      quoteLineItemSubtotal: [null],
      quoteLineItemGeneralDiscountType: ['percentage'],
      quoteLineItemGeneralDiscountValue: [null],
      quoteLineItemFreightTotal: [null],
      quoteLineItemFreight: [null],
      quoteLineItemTotal: [null],
      supplierCurrency: [null],
      quoteLineItemApplicableTaxProfile: [null],
      quoteLineItemTaxAmount: [null],
      quoteLineItemTaxType: [null],
    });

    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    this.lineItemAttachmentTypeData =
      await this.quoteService.fetchAllQuteAttachmentTypeByRfqToken(
        'QuoteLineItemAttachmentType'
      );

    this.delineReasonData =
      await this.quoteService.fetchAllDeclineReasonByRfqToken();

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);

    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params['rfqId'] != '' && params['quoteId'] != '') {
        this.rfqId = Number(params['rfqId']);
        this.quoteId = Number(params['quoteId']);

        this.getQuoteDraftData();
      }
    });

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);
    this.fetchRfqDetails();

    this.checkisTabEnabled();console.log("dataSource",this.dataSource);
  }

  async save(isDraft?: boolean) {
    console.log('INSIDE SAVE');

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    } else {
      const missingFields = this.isValidRequiredFields();
      console.log({ missingFields });
      if (missingFields.length > 0) {
        return;
      }
    }

    const lineitems = this.lineItemtableForm.value.rows;
    // Get items that are active and not in attachedProducts array

    const activeLineItems = lineitems.filter(
      (item: { isActive: number }) => item.isActive === 1
    );

    if (activeLineItems.length == 0) {
      this.snack.open('Atleast one active line item should be present.', 'OK', {
        duration: 3000,
      });
      return;
    }

    this.fullLoaderService.showLoader();
    // Loop through each attachment and upload to S3
    for (let rowIndex = 0; rowIndex < lineitems.length; rowIndex++) {
      const row = lineitems[rowIndex];
      let attachmentFiles: any = {};
      let attachmentArray = row.attachments || [];
      const partNumber = row.partNumber;
      console.log(attachmentArray, 'attachmentArray', 'lineitems', lineitems);

      attachmentArray = attachmentArray.filter(
        (item: { file: any }) => item.file
      );

      // generate the s3 upload content for each attachment file
      let uploadPath = `quotation/${this.quoteId}/${partNumber}`;

      await Promise.all(
        attachmentArray.map(async (attachment: any, index: any) => {
          if (!attachment.file) {
            return;
          }

          let fileName = attachment.file.name;
          let fileExt = attachment.name.slice(
            ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
          );

          let fileNameSystem = `${uuidv4()}.${fileExt}`;

          attachment.systemName = fileNameSystem; //This name denotes the fileNames for our system records
          let s3Location = `${uploadPath}/${fileName}`; //!this location to be verified before starting upload

          let _s3Params = {
            fileKey: s3Location,
            fileContentType: (<File>attachment.file).type,
          };
          attachment.s3Params = _s3Params;
          attachmentFiles[attachment.file.name] = attachment.file;
        })
      );

      // get presigned urls for all the attachments in bulk
      row.attachments = await this.SettingsService.getBulkAttachmentUrlsByRfqToken(
        attachmentArray
      );

      row.attachments.map(async (attachment: any) => {
        attachment.s3_path = this.awsSdkService.extractS3LocationFromUrl(
          attachment.s3_path
        );
        attachment.fileKey = attachment.s3Params.fileKey;
      });

      // upload all the iamges to s3 bucket
      await Promise.all(
        row.attachments.map(async (attachment: any) => {
          this.webApiService.putRequestExternalApi(
            attachment.s3_path,
            attachmentFiles[attachment.name]
          );
        })
      );
    }

    const lineItemHeaderData = this.secondFormGroup.value;
    console.log('lineItemHeaderData', lineItemHeaderData);
    // if (!this.isValidFreight()) {
    //   this.snack.open('Freight details are required before proceeding.', 'OK', {
    //     duration: 3000
    //   });
    //   this.fullLoaderService.hideLoader()
    //   return;
    // }

    const lineItemTable = this.lineItemtableForm.value;
    console.log('lineItemTable');
    const params1 = {
      section: 'tab2',
      isDraft: isDraft,
      quoteStatus: isDraft ? 14 : 2,
      tabId: 1,
      quoteId: this.quoteId,
      lineItemData: lineItemHeaderData,
      lineItemTableData: lineItemTable,
      rfqId: this.rfqId,
    };

    // console.log(this.lineItemtableForm.value,this.rfqId)
    if (
      this.quoteId &&
      this.isSaved &&
      this.secondFormGroup.get('quoteLineItemHeaderId')?.value != null
    ) {
      console.log('updateQuoteAsDraft called in quoteLineItems');
      const result1 = await this.quoteService.updateQuoteAsDraftByRfqToken(params1);

      if (result1?.data) {
        console.log(
          'result1 of updated quote draft from line items',
          result1.data
        );
        this.fullLoaderService.hideLoader();

        // this.snack.open(`Line Item Data Saved`, "OK", { duration: 3000 });
        // this.next()
        if (isDraft) {
          this.router.navigate(['/operations/supplier-quote-list'], {
            // { name: 'Draft', label: 'Quote' },
            queryParams: {
              selectedStatus: 'Draft',
              label: 'Quote',
            },
          });
        }
      } else {
        this.fullLoaderService.hideLoader();
        throw new Error('Invalid response format: Expected { data: number }');
      }
    } else {
      console.log('saveQuotedAsDraft is called in quoteLineItems');
      const result1 = await this.quoteService.saveQuoteAsDraftByRfqToken(params1);

      if (result1?.data) {
        // this.snack.open(`Line Item Data Saved`, "OK", { duration: 3000 });

        this.isSaved = true;
        // // this.next()
        // if(isDraft){
        //   this.router.navigate(['/operations/supplier-quote-list'], {
        //     // { name: 'Draft', label: 'Quote' },
        //     queryParams: {
        //       selectedStatus: 'Draft',
        //       label: 'Quote'
        //     }
        //   });
        // }
      } else {
        this.fullLoaderService.hideLoader();
        throw new Error('Invalid response format: Expected { data: number }');
      }
    }
  }

  isValidFreight(): boolean {
    const freightField = this.secondFormGroup.get('quoteLineItemFreight');

    // Check if freight details are provided
    if (!freightField?.value || freightField?.value.length === 0) {
      return false; // Return false if freight details are not provided
    }

    return true; // Return true if freight details are valid
  }

  async back() {
    this.router.navigate(['rfqToken', 'quote-header-details'], {
      queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
    });
  }
  closeLineItems() {
    this.router.navigate(['operations', 'all-documents']);
  }
  async next() {
    // if (this.isSaved) {

    //   this.activatedRoute.queryParams.subscribe(async params => {

    //     if (params['rfqId'] != '' && params['quoteId'] != '' ) {

    //       this.rfqId = params['rfqId']
    //       this.quoteId = params['quoteId']

    //       this.router.navigate([
    //         "dashboard", "quote", "create", 'payment-terms'
    //       ],
    //         {
    //           queryParams: { rfqId: this.rfqId, quoteId:this.quoteId }
    //         }
    //       );

    //   }})

    // }

    if (this.isSaved) {
      this.router.navigate(['rfqToken', 'quote-header-details'], {
        queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
      });
    }
    // else{
    //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    // }
  }

  // async close() {}

  calculateRowValues(index: number): void {
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row);
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = unitCost * (1 - discount / 100);
    const totalCost = quantity * discountedUnitPrice;

    row
      .get('discountedUnitPrice')
      ?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary();
  }

  calculateCostSummary() {
    let subTotalCost = 0;
    let totalDiscount = 0;
    let totalUnitCost = 0;
    let totalCost = 0;
    let totalFreightAmount = 0;

    let taxPercentage = 0;
    let taxAmount = 0;

    const lineItemTable = this.lineItemtableForm.value;

    const row = lineItemTable.rows;

    row.forEach((item: any) => {
      if (item.isActive === 1) {
        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount || 0;
        const discountedUnitPrice = item.discountedUnitPrice || 0;

        const rowTotalCost = discountedUnitPrice * quantity;
        // const rowDiscount = discount * quantity;
        // const rowDiscount = unitCost * (discount / 100);
        const rowDiscount = unitCost * (discount / 100) * quantity;
        const rowUnitCost = unitCost * quantity;

        subTotalCost += rowTotalCost;
        totalDiscount += rowDiscount;
        totalUnitCost += rowUnitCost;
        totalCost += rowTotalCost;
        
        console.log({totalDiscount});
        }
        
    });

    // Reset general discount amount before recalculation
    this.generalDiscountAmount = 0;

    if (
      this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value !=
      null
    ) {
      const type = this.secondFormGroup.get(
        'quoteLineItemGeneralDiscountType'
      )?.value;

      const genDiscount = parseFloat(
        this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value ||
          '0'
      );

      if (!isNaN(genDiscount) && genDiscount > 0) {
        if (type == 'percentage') {
          // Compute discount amount on current total before applying it
          this.generalDiscountAmount = (genDiscount / 100) * totalCost;
          totalCost -= this.generalDiscountAmount;
        } else {
          this.generalDiscountAmount = genDiscount;
          totalCost = totalCost - genDiscount;
        }
      }
    }
    // if(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value != null){

    //   const type = this.secondFormGroup.get('quoteLineItemFreightTotal')?.value

    //   const freight = parseFloat(this.secondFormGroup.get('quoteLineItemFreight')?.value || '0');

    //   if(type == 'percentage' ){
    //     totalCost += (freight / 100) * totalCost;
    //   }
    //   else{
    //     totalCost = totalCost + freight;
    //   }
    //   }
    if (this.secondFormGroup.get('quoteLineItemFreight')?.value != null) {
      console.log('hi');
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value;

      if (freight.length > 0) {
        freight.forEach(
          (item: { freightValue: string; freightType: string }) => {
            const freightValue = parseFloat(item.freightValue);

            if (item.freightType === 'percentage') {
              totalCost += (freightValue / 100) * totalCost; // Apply percentage freight value
              totalFreightAmount += (freightValue / 100) * totalCost;
            } else if (item.freightType === 'amount') {
              totalCost += freightValue; // Add flat freight amount
              totalFreightAmount += freightValue;
            }
          }
        );
      }
    }

    if (
      this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value !=
      null
    ) {
      const selectedTaxId = this.secondFormGroup.get(
        'quoteLineItemApplicableTaxProfile'
      )?.value;

      const selectedTaxProfile = this.taxStatusData.find(
        (tax) => tax.taxId === Number(selectedTaxId)
      );

      if (selectedTaxProfile && selectedTaxProfile.taxPercentage) {
        taxPercentage = parseFloat(selectedTaxProfile.taxPercentage);
      }
      console.log("subTotalCost",subTotalCost);
      console.log("totalCost",totalCost);
      // Check if valid tax percentage
      if (!isNaN(taxPercentage) && taxPercentage > 0) {
        taxAmount = (subTotalCost * taxPercentage) / 100;
        totalCost = totalCost + taxAmount;
      }
    }

    console.log(
      this.secondFormGroup.get('quoteLineItemFreightTotal')?.value,
      totalFreightAmount,
      'totalFreightAmount'
    );

    this.secondFormGroup
      .get('quoteLineItemTaxAmount')
      ?.setValue(taxAmount, { emitEvent: false });

    this.secondFormGroup
      .get('quoteLineItemFreightTotal')
      ?.setValue(totalFreightAmount, { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemListPriceSubtotal')
      ?.setValue(totalUnitCost, { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemDiscount')
      ?.setValue(totalDiscount, { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemSubtotal')
      ?.setValue(subTotalCost, { emitEvent: false });
    this.secondFormGroup
      .get('quoteLineItemTotal')
      ?.setValue(totalCost, { emitEvent: false });

    const convert_rows = this.lineItemtableForm.get('rows') as FormArray;

    // Loop through all rows in the FormArray
    for (let i = 0; i < convert_rows.length; i++) {
      const row = convert_rows.at(i); // Get the row FormGroup at index i

      const baseCurrency = this.headerData?.currencyId?.currencyCode || 'EUR';
      const supplierCurrency =
        this.secondFormGroup.get('supplierCurrency')?.value?.currencyCode ||
        'EUR';
      const supplierUnitCost = row.get('unitCost')?.value || 0;
      const supplierTotalCost = row.get('totalCost')?.value || 0;

      console.log(
        baseCurrency,
        supplierCurrency,
        supplierUnitCost,
        supplierTotalCost,
        'supplierAmount'
      );

      // Check if the buyer currency is available
      if (!baseCurrency) {
        this.snack.open('Buyer does not have a currency code', 'Close', {
          duration: 4000,
        });
        return;
      }

      // Check if the exchange rate for this buyer currency is already cached
      if (!this.exchangeRatesCache[baseCurrency]) {
        // Fetch exchange rates for the buyer currency if not cached

        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe(
          (res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
              console.log(
                'Exchange rates fetched successfully:',
                res.conversion_rates
              );

              // Apply conversion after fetching the rates
              this.applyConversionToUnitCost(
                row,
                supplierCurrency,
                baseCurrency,
                supplierUnitCost
              );
              this.applyConversionToTotalCost(
                row,
                supplierCurrency,
                baseCurrency,
                supplierTotalCost
              );
            } else {
              console.error('API error:', res['error-type']);
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open(
                'Currency exchange API limit exceeded. Please renew the subscription to view actual conversion values. Some users may experience disruptions in currency conversion functionality.',
                'OK',
                { duration: 7000 }
              );
            } else {
              console.error('Error fetching exchange rates:', error);
            }
          }
        );
      } else {
        // If rates are cached, directly apply conversion
        this.applyConversionToUnitCost(
          row,
          supplierCurrency,
          baseCurrency,
          supplierUnitCost
        );
        this.applyConversionToTotalCost(
          row,
          supplierCurrency,
          baseCurrency,
          supplierTotalCost
        );
      }
    }
  }

  onEditGeneralDiscountClick() {
    this.isEditingGeneralDiscount = true;
    setTimeout(() => {
      const inputEl = this.generalDiscountInputs?.first?.nativeElement;
      if (inputEl) {
        inputEl.focus();
        try { inputEl.select?.(); } catch {}
      }
    }, 0);
  }

  onGeneralDiscountBlur() {
    // Lock the field again and recalculate totals
    this.isEditingGeneralDiscount = false;
    this.calculateCostSummary();
  }

  calculateTaxAmount(index: number): void {
    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row);
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = unitCost * (1 - discount / 100);
    const totalCost = quantity * discountedUnitPrice;

    row
      .get('discountedUnitPrice')
      ?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary();
  }

  populateForm(data: any[]) {
    console.log(data);
    data.forEach((item) => {
      this.addRow(item);
    });
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) && // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32) // space
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {
    // const discountedUnitPrice = this.calculateDiscountedUnitPrice(data);
    // const totalCost = this.calculateTotalCost(data, discountedUnitPrice);
    console.log({data});
    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      partNumber: [data.partNumber || ''],
      supplierPartNumber: [data.supplierPartNumber || ''],
      itemDescription: [data.itemDescription || ''],
      impaId: [data.impaId || 0],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      customsCode: [data.customsCode || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity|| 0],
      unitCost: [data.price || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [data.price || 0.00],
      discount: [data.discount || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [data.discountedUnitPrice || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      totalCost: [data.totalCost || 0.00, Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost:[data.totalCost || 0.00],
      isActive: [data.isActive ],
      declineReasonTypeId : [data.declineReasonTypeId || null],
      delineOtherReason:[data.delineOtherReason || ''],
      declineReasonDescription:[data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],

      isNew: [data.isNew || 0],
      isAddedBySupplier: [data.isAddedBySupplier || 0],
      supplierProductId: [data.supplierProductId || 0],
      addedLineItempartNumber: [data.addedLineItempartNumber || 0],
    });

    console.log(this.lineItemtableForm.get('rows'), 'test 1');

    // this.setupRowListeners(row);
    this.rows.push(row); // Add the row to the FormArray

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  addNewLineItem() {
    const obj = {
      position: this.dataSource.length + 1,
      id: null,
      partNumber: null,
      supplierPartNumber: null,
      itemDescription: null,
      impaId: null,
      buyerComment: null,
      supplierComment: '',
      customsCode: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom: null,
      supplierQuantity: 0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive: 1,
      isNew: 1,
      isAddedBySupplier: 1,
      supplierProductId: 0,
      addedLineItempartNumber: 0,
    };

    // const obj = {
    //   position: this.dataSource.length + 1,   // Increment position based on the length of dataSource
    //   id: null,
    //   partNumber: null,
    //   supplierPartNumber: null,
    //   itemDescription: null,
    //   impaId: null,
    //   buyerComment: null,
    //   supplierComment: '',
    //   customsCode: '',
    //   attachments: [],
    //   uom: null,
    //   quantity: 0,
    //   supplierUom: null,
    //   supplierQuantity: 0,
    //   price:0,
    //   discount:null,
    //   totalCost: null,
    //   isActive: true,
    //   isNew: true
    // };

    this.addRow(obj);
    this.dataSource = [...this.dataSource, obj];
    // this.dataSource = lineItemData

    this.snack.open('Search a part number and select it to add a new line item.', 'OK', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-info'],
    });

    console.log(this.lineItemtableForm.get('rows'), 'test 2', this.dataSource);
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  async prefillRfqLineItems() {
    if (this.rfqId) {
      this.fullLoaderService.showLoader();

      let params = {
        rfqId: this.rfqId,
        supplierId: this.userId,
      };

      const data = await this.quoteService.fetchRfqLineItemDetailsByRfqToken(params);

      if (data && data.length > 0) {
        this.dataSource = [];

        const lineItemData = data;

        lineItemData.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            partNumber: item.partNumber,
            supplierPartNumber: item.partNo,
            itemDescription: item.itemDescription,
            impaId: item.supplierProductId,
            buyerComment: item.buyerComments,
            supplierComment: '',
            customsCode: '',
            attachments: '',
            uom: item.uom,
            quantity: item.quantity,
            supplierUom: item.uom,
            supplierQuantity: item.quantity,
            unitCost: item.unitCost,
            discount: item.discount,
            totalCost: item.price,
            isActive: item.isActive,
          };

          this.dataSource.push(obj);
        });
      }

      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader();
    }
  }
  async fetchRfqDetails() {
    // this.fullLoaderService.showLoader()
    let paramsData = {
      rfqId: this.rfqId,
      supplierId: this.userId,
    };
    const data = await this.quoteService.fetchRfqDetailsByRfqToken(paramsData);
    this.headerData = data.rfqData[0];
    console.log('Header Data ', this.headerData);
    this.fullLoaderService.hideLoader();
  }

  async rfqActions(action: string) {
    if (action == 'download') {
      this.fullLoaderService.showLoader();

      let fileName = this.headerData?.rfqRefNumber + '.pdf';

      let data = {
        supplierId: this.userId,
        rfqId: this.rfqId,
      };
      const pdf = await this.SettingsService.generateSupplierRfqAttachmentByRfqToken(
        data
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Create a temporary <a> element
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.fullLoaderService.hideLoader();
    } else if (action == 'decline') {
      this.showDeclineConfirmationDialogue = true;
    } else if (action == 'acknowledge') {
      this.fullLoaderService.showLoader();

      let data = {
        operation: action,
        selectedRfqId: [this.headerData.supplierRfqId],
      };

      await this.SettingsService.rfqOperationsByRfqToken(data);
      this.fullLoaderService.hideLoader();
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });
    }
    this.fetchRfqDetails();
  }

  async selectMatTabLink(tabItem: any) {
    // if(tabItem.route == 'header'){

    //     this.back()

    // }

    // else if(tabItem.route == 'payment-terms'){

    //   if(this.isSaved){

    //    this.next()

    //   }
    //   else{
    //     this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
    //   }
    // }

    //called save to enable to choose any tab and also save the current filled tab details
    await this.save();
    if (this.showNotification) return;

    if (tabItem.route == 'header') {
      if (this.isSaved) {
        this.router.navigate(['rfqToken', 'quote-header-details'], {
          queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
        });
      }

      // else {
      //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
      // }
    } else if (tabItem.route == 'payment-terms') {
      // if (this.tabEnabled) {

      //   this.activatedRoute.queryParams.subscribe(async params => {

      //     if (params['rfqId'] != '' && params['quoteId'] != '') {

      //       this.rfqId = params['rfqId']
      //       this.quoteId = params['quoteId']

      //       this.router.navigate([
      //         "dashboard", "quote", "create", 'payment-terms'
      //       ],
      //         {
      //           queryParams: { rfqId: this.rfqId, quoteId: this.quoteId }
      //         }
      //       );

      //     }

      //   })

      // }
      // else {
      //   this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
      // }

      if (this.isSaved) {
        this.router.navigate(['rfqToken', 'quote-payment-terms'], {
          queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
        });
      } else {
        this.snack.open(`please save the 'Line item' tab first`, 'OK', {
          duration: 3000,
        });
      }
    } else if (tabItem.route == 'preview') {
      if (this.isSaved) {
        this.router.navigate(['rfqToken', 'quote-preview'], {
          queryParams: { rfqId: this.rfqId, quoteId: this.quoteId },
        });
      } else {
        this.snack.open(`please save the 'Line item' tab first`, 'OK', {
          duration: 3000,
        });
      }
    }
  }

  async checkisTabEnabled() {
    // const data2 = await this.quoteService.getQuoteDraftData('tab1', this.quoteId)
    // if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {
    //   this.tabEnabled = true
    // }
  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.showCloseDialogue = true;
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    // setTimeout(() => {
    //   if (this.table) {
    //     this.table.recalculate();
    //   }
    // }, 100);
  }

  toggleSidebar(value: boolean, section: string, index?: number) {
    if (section == 'attachment') {
      this.showAddDocumentSection = value;
      if (index !== undefined) {
        this.selectedLineItemIndex = index;
      }
    } else if (section == 'cost') {
      this.showAddCostSection = value;
    } else if (section == 'decline') {
      if (index !== undefined) {
        const rows = this.lineItemtableForm.get('rows') as FormArray;

        const selectedRow = rows.at(index);

        if (selectedRow.value.isNew === 1) {
          rows.removeAt(index);

          console.log(
            this.lineItemtableForm.get('rows') as FormArray,
            this.dataSource,
            'removed'
          );

          this.dataSource.splice(index, 1);

          this.dataSource = [...this.dataSource];

          this.snack.open(`New line item removed.`, 'OK', { duration: 3000 });

          this.calculateCostSummary();
        } else {
          this.selectedLineItemIndex = index;
          this.showDeclineSection = value;
        }
      }
    } else if(section == 'freight'){
      this.isFreight = true;
    }
  }

  fileOver(event: any) {}
  fileLeave(event: any) {}

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try {
      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (
        this.selectedAttachmentType == undefined ||
        this.selectedAttachmentType == null
      ) {
        this.snack.open('Please select the attachment type.', 'OK', {
          duration: 3000,
        });
        return;
      }

      if (
        this.selectedAttachmentType == 1 ||
        this.selectedAttachmentType == 4
      ) {
        if (
          this.hazardousDeclaration == null ||
          this.hazardousDeclaration == undefined
        ) {
          this.snack.open('Hazardous Declaration can not be empty.', 'OK', {
            duration: 3000,
          });

          return;
        }
      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();

      if (this.selectedLineItemIndex != null) {
        this.uploadedAttachmentsArray =
          rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];

        if (this.uploadedAttachmentsArray.length > 5) {
          throw new Error('Maximum 5 files allowed for a product!');
        }

        const fileEntries = files
          .filter((entry) => entry.fileEntry.isFile)
          .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries, 'fileEntries');

        if (fileEntries.length === 0) {
          throw new Error('Please upload valid files!');
        }
        if (fileEntries.length > 5) {
          throw new Error('Maximum 5 files allowed for a product!');
        }

        await new Promise((res, rej) => {
          fileEntries.map((fileEntry) => {
            fileEntry.file(async (file) => {
              let fileExt = file.name.split('.').pop();
              if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
                // rej('Invalid filetype!');
                return;
              }

              if (file.size > this.maxFileSize) {
                throw new Error('File size must be less than 5MB!');
              }

              let uploadedAttachment: any = {
                lineItemIndex: this.selectedLineItemIndex,
                dataUrl: '',
                name: file.name,
                file: file,
                attachmentType: this.selectedAttachmentType,
                hazardousDeclaration: this.hazardousDeclaration,
              };

              await new Promise((res, rej) => {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                  uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                  res(true);
                };
                reader.readAsDataURL(file); // Read the file as a data URL
              });

              this.uploadedAttachmentsArray.push(uploadedAttachment);
              res(file);
            });
          });
        });

        rows.at(this.selectedLineItemIndex).patchValue({
          attachments: this.uploadedAttachmentsArray,
        });
        console.log(
          rows.at(this.selectedLineItemIndex).get('attachments')?.value,
          this.uploadedAttachmentsArray
        );

        this.fullLoaderService.hideLoader();
      }
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  onDeclineReasonChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == '7') {
      this.showOtherReason = true;
    } else {
      this.showOtherReason = false;
    }
  }

  onAttachmentTypeChange(event: MatSelectChange) {
    const selectedValue = event.value;

    if (selectedValue == 1 || selectedValue == 4) {
      this.showHazardousDeclaration = true;
    } else {
      this.showHazardousDeclaration = false;
    }
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  declineLineItem() {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    if (this.declineReason == undefined || this.declineReason == null) {
      this.snack.open('Please select the decline reason.', 'OK', {
        duration: 3000,
      });
      return;
    }

    if (
      this.declineReason == 7 &&
      (this.otherReason == null || this.otherReason == '')
    ) {
      this.snack.open('Other reason can not be empty.', 'OK', {
        duration: 3000,
      });

      return;
    }

    const reason = this.delineReasonData.find(
      (item) => item.id === this.declineReason
    );

    const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

    if (this.selectedLineItemIndex != null) {
      // const selectedRow = rows.at(this.selectedLineItemIndex);

      // if (selectedRow.value.isNew === 1) {

      //   rows.removeAt(this.selectedLineItemIndex);

      //   console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

      //   this.dataSource.splice(this.selectedLineItemIndex, 1);
      //     // Trigger change detection if you're using MatTable
      //   this.dataSource = [...this.dataSource];

      //   this.snack.open(`New line item removed.`, "OK", { duration: 3000 });
      // }
      // else {

      rows.at(this.selectedLineItemIndex).patchValue({
        isActive: 0,
        declineReasonTypeId: this.declineReason,
        delineOtherReason: this.otherReason,
        declineReasonDescription: reasonDesc,
        attachments: [],
        supplierQuantity: 0,
      });

      this.snack.open(
        `Line Item Declined, selected line item attachments are removed`,
        'OK',
        { duration: 3000 }
      );
    }
    // }

    this.showDeclineSection = false;
    this.declineReason = null;
    this.otherReason = '';
    this.selectedLineItemIndex = null;

    this.calculateCostSummary();
  }

  restoreLineitem(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId: null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity: quantityValue || 1,
    });

    this.snack.open(`Line Item Restored`, 'OK', { duration: 3000 });

    this.calculateCostSummary();
  }

  isDecline(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const isActive = row.get('isActive')?.value;

    // Return the value (true or false)
    return isActive === 0;
  }

  getDeclineReason(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const reason = row.get('declineReasonDescription')?.value || '';

    return `Declined - ${reason || 'No reason provided'}`;
  }

  isNew(index: number) {
    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    const isNew = row.get('isNew')?.value;

    // Return the value (true or false)
    return isNew === 1;
  }

  addCost() { 
    this.freightDescription = 'Freight';
    this.isFreightCost = true;
    this.showAddCostSection = true; 
    console.log("freightDescription",this.freightDescription);
  }

  addMoreCostAtFreight(){
    let params = {
      id: null,
      freightDescription: this.freightDescription,
      freightType: this.freightType,
      freightValue: this.freightValue || 0,
      isActive: 1,
    };
    console.log('params', params);
    this.addedAdditionalCost.push(params);

    this.secondFormGroup
      .get('quoteLineItemFreight')
      ?.setValue(this.addedAdditionalCost);

    console.log(this.addedAdditionalCost);
    console.log(this.secondFormGroup);
    console.log(
      'test',
      this.secondFormGroup.get('quoteLineItemFreight')?.value
    );
    this.calculateCostSummary();

    this.showAddCostSection = true;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
    this.isFreightCost = false;
  }

  addMoreCost(){
    this.showAddCostSection = true;
  }

  cancelAddCost() {
    this.showAddCostSection = false;
    // Do not mutate existing added costs; just reset the temporary inputs
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
    this.isFreightCost = false;
  }

  removeAdditionalCost(index: number) {
    // Check if the cost at the given index exists
    if (index > -1 && index < this.addedAdditionalCost.length) {
      // Remove the cost from the array
      this.addedAdditionalCost.splice(index, 1);

      // Update the form control with the new list of added costs
      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost);

      // Recalculate the cost summary after removal
      this.calculateCostSummary();

      // Optionally, show a message to inform the user that the cost has been removed
      this.snack.open('Cost removed successfully.', 'OK', {
        duration: 3000,
      });
    } else {
      // Show a message if the index is invalid or cost does not exist
      this.snack.open('Invalid cost index.', 'OK', {
        duration: 3000,
      });
    }
  }

//   onFreightEditComplete(index: number, item: any) {
//   if (item.freightDescription?.trim()?.toLowerCase() === 'freight') {
//     const newValue = Number(item.freightValue);

//     // Skip invalid or unchanged values
//     if (isNaN(newValue)) {
//       return;
//     }

//     // Find the freight entry in addedAdditionalCost and update it
//     const existingFreight = this.addedAdditionalCost.find(
//       (cost: any) => cost.freightDescription?.trim()?.toLowerCase() === 'freight'
//     );

//     if (existingFreight) {
//       existingFreight.freightValue = newValue;
//     }

//     // Update form group with modified cost list
//     this.secondFormGroup
//       .get('quoteLineItemFreight')
//       ?.setValue(this.addedAdditionalCost);

//     console.log(this.addedAdditionalCost);

//     // Recalculate cost summary
//     this.calculateCostSummary();

//   }
// }

onFreightEditComplete(index: number, item: any, event: any) {
  // Only act for freight
  if (item.freightDescription?.trim()?.toLowerCase() !== 'freight') return;

  const oldValue = Number(item.freightValue);
  const newValue = Number(event.target.value);

  // Skip if invalid or unchanged
  if (isNaN(newValue) || newValue === oldValue) return;

  // Skip if initial freightValue is 0 or empty
  if (!oldValue || oldValue === 0) return;

  // Update the value in addedAdditionalCost (if exists)
  const existingFreight = this.addedAdditionalCost.find(
    (cost: any) => cost.freightDescription?.trim()?.toLowerCase() === 'freight'
  );

  if (existingFreight) {
    existingFreight.freightValue = newValue;

    console.log("existingFreight",existingFreight.freightValue);
    // Update the form control as well
    this.secondFormGroup
      .get('quoteLineItemFreight')
      ?.setValue(this.addedAdditionalCost);

    // Recalculate cost summary
    this.calculateCostSummary();

  }
  this.isFreight = false;
}





  saveAdditionalCost() {
    if (
      this.freightDescription == '' ||
      this.freightType == '' ||
      this.freightValue == null
    ) {
      this.snack.open('Please fill the additional cost details.', 'OK', {
        duration: 3000,
      });
      return;
    }
    let params = {
      id: null,
      freightDescription: this.freightDescription,
      freightType: this.freightType,
      freightValue: this.freightValue,
      isActive: 1,
    };
    console.log('params', params);
    this.addedAdditionalCost.push(params);

    this.secondFormGroup
      .get('quoteLineItemFreight')
      ?.setValue(this.addedAdditionalCost);

    console.log(this.addedAdditionalCost);
    console.log(this.secondFormGroup);
    console.log(
      'test',
      this.secondFormGroup.get('quoteLineItemFreight')?.value
    );
    this.calculateCostSummary();

    this.showAddCostSection = false;
    this.freightDescription = '';
    this.freightType = 'amount';
    this.freightValue = null;
  }

  async getQuoteDraftData() {
    this.fullLoaderService.showLoader();

    const data = await this.quoteService.getQuoteDraftDataByRfqToken(
      'tab2',
      Number(this.quoteId)
    );

    if (
      data &&
      data.length > 0 &&
      Object.keys(data[0]).length > 0 &&
      data[0].quotationLineItems.length > 0
    ) {
      if (data[0].quotationLineItems[0].quoteLineItemDetailsId) {
        this.isSaved = true;
      }

      this.secondFormGroup.patchValue({
        quoteLineItemHeaderId: data[0].quoteLineItemHeaderId || '',
        quoteLineItemListPriceSubtotal:
          data[0].quoteLineItemListPriceSubtotal || '',
        quoteLineItemDiscount: data[0].quoteLineItemDiscount || '',
        quoteLineItemSubtotal: data[0].quoteLineItemSubtotal || '',
        quoteLineItemGeneralDiscountType:
          data[0].quoteLineItemGeneralDiscountType || 'percentage',
        quoteLineItemGeneralDiscountValue:
          data[0].quoteLineItemGeneralDiscountValue || '',
        quoteLineItemFreightTotal: data[0].quoteLineItemFreightTotal || '',
        quoteLineItemFreight: data[0].quoteLineItemFreight || '',
        quoteLineItemTotal: data[0].quoteLineItemTotal || '',
        supplierCurrency: data[0].supplierCurrency,
        quoteLineItemApplicableTaxProfile:
          data[0].quoteLineItemApplicableTaxProfile || null,
        quoteLineItemTaxAmount: data[0].quoteLineItemTaxAmount || 0,
      });

      
      let resolvedTaxType!: string | null;

      const selectedTaxProfileId = data[0].quoteLineItemApplicableTaxProfile;
      if (!resolvedTaxType && selectedTaxProfileId && Array.isArray(this.taxStatusData) && this.taxStatusData.length > 0) {
        const selectedTaxProfile = this.taxStatusData.find(
          (t: any) => t.taxId === Number(selectedTaxProfileId)
        );
        if (selectedTaxProfile) {
          resolvedTaxType = selectedTaxProfile.taxType || null;
        }
        this.secondFormGroup.patchValue({
          quoteLineItemTaxType: resolvedTaxType,
        });
        this.quoteLineItemTaxType = resolvedTaxType;

      }

      

      console.log(
        'lineitmefreight',
        this.secondFormGroup.get('quoteLineItemFreight')?.value
      );

      this.dataSource = [];

      console.log("quotationLineItems",data[0].quotationLineItems);

      if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {
        data[0].quotationLineItems.forEach(
          (
            item: {
              supplierProductId: any;
              isAddedBySupplier: any;
              leadTime: any;
              attachments: any;
              declineReasonTypeId: any;
              declineReasonDescription: any;
              delineOtherReason: any;
              supplierQuantity: any;
              supplierUom: any;
              uom: any;
              customsCode: any;
              buyerComment: any;
              impaId: any;
              supplierPartNumber: any;
              quoteLineItemDetailsId: any;
              isActive: any;
              partNumber: any;
              itemDescription: any;
              unitCost: any;
              discount: any;
              supplierComment: any;
              quantity: any;
              discountedUnitPrice: any;
              totalCost: any;
            },
            index: number
          ) => {
            const obj = {
              position: index + 1, // Assign position based on index
              id: item.quoteLineItemDetailsId,
              partNumber: item.partNumber,
              supplierPartNumber: item.supplierPartNumber,
              itemDescription: item.itemDescription,
              impaId: item.impaId,
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              customsCode: item.customsCode,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: item.unitCost,
              discount: item.discount,
              discountedUnitPrice: item.discountedUnitPrice,
              totalCost: item.totalCost,
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments: item.attachments,
              leadTime: item.leadTime,
              isNew: 0,
              isAddedBySupplier: item.isAddedBySupplier,
              supplierProductId: item.supplierProductId,
            };

            this.dataSource.push(obj); // Push each object to dataSource
          }
        );

        console.log("dataSource",this.dataSource);

        this.populateForm(this.dataSource);
        // this.toggleSelectAllLineItem(true)
      }
      this.onGeneralDiscountBlur();
      this.fullLoaderService.hideLoader();
    } else {
      this.prefillRfqLineItems();
      this.fetchDefaultCurrency();
    }

    this.fullLoaderService.hideLoader();
  }

  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

  // Function to display the notification with missing fields
  showMissingFieldsNotification(
    missingFields: { section: string; fields: string[] }[]
  ) {
    let message =
      '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

    // Loop through each section and list its missing fields
    missingFields.forEach((missingField) => {
      message += `<strong>${missingField.section}:</strong><br>`; // Add section name
      message += missingField.fields
        .map((field) => `  • ${field}`)
        .join('<br>'); // List missing fields with bullet points
      message += '<br><br>'; // Add extra spacing between sections
    });

    this.notificationMessage = message;
    this.notificationTitle = 'Missing Fields';
    this.notificationType = 'error'; // Change this to 'info' for informational notifications
    this.showNotification = true; // Display the notification
  }

  // // Validation logic to check for required fields
  // isValidRequiredFields(): { section: string, fields: string[] }[] {
  //   console.log("isValidRequiredFields called")
  //   const missingFields: { section: string, fields: string[] }[] = [];

  //   // Check for missing fields in Tab1 (Line Items Section)
  //   const lineItemMissingFields: string[] = [];
  //   // const lineItems = this.secondFormGroup.value;
  //   const lineItems = this.lineItemtableForm.value.rows
  //   console.log({lineItems});
  //   if (!lineItems.unitCost || lineItems.unitCost <= 0) {
  //     lineItemMissingFields.push('Unit Cost for line item');
  //   }
  //   if (!lineItems.leadTime || lineItems.leadTime <= 0) {
  //     lineItemMissingFields.push('Lead Time for line item');
  //   }

  //   if (lineItemMissingFields.length > 0) {
  //     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  //   }

  //   // Show notification if there are missing fields
  //   if (missingFields.length > 0) {
  //     this.showMissingFieldsNotification(missingFields);
  //   }

  //   return missingFields;
  // }

  isValidRequiredFields(): { section: string; fields: string[] }[] {
    const missingFields: { section: string; fields: string[] }[] = [];

    // ✅ Check for missing fields in Tab1 (Line Items Section)
    const lineItemMissingFields: string[] = [];
    const lineItems = this.lineItemtableForm.value?.rows || [];

    lineItems.forEach((item: any, index: number) => {

      if (item.isActive === 0) {
        return;
      }
      
      if (!item.unitCost || item.unitCost <= 0) {
        lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
      }
      if (!item.leadTime || item.leadTime <= 0) {
        lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
      }
    });
    const form = this.secondFormGroup;

    if (!form.get('supplierCurrency')?.value) {
      lineItemMissingFields.push('Preferred Currency');
    }

    if (lineItemMissingFields.length > 0) {
      missingFields.push({
        section: 'Line Items',
        fields: lineItemMissingFields,
      });
    }

    // Show notification if there are missing fields
    if (missingFields.length > 0) {
      this.showMissingFieldsNotification(missingFields);
    }

    return missingFields;
  }

  getLineItemAttachment() {
    const rows = this.lineItemtableForm.value.rows;

    if (this.selectedLineItemIndex != null) {
      const row = rows[this.selectedLineItemIndex];
      const attachment = row.attachments || [];
      // Get the value of the 'isActive' field
      return attachment;
    } else {
      return [];
    }
  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.SettingsService.getAllCurrenciesByFliterKeyValueByRfqToken(
      pageMeta.serachParam,
      pageMeta
    );
  }

  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }

  onPartNumberSelected(event: any, index: number) {
    console.log(event, 'event');

    const selectedItem = event;

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    rows.at(index).patchValue({
      partNumber: selectedItem.partNo,
      supplierPartNumber: selectedItem.partNo,
      itemDescription: selectedItem.ItemName,
      impaId: selectedItem.impaId,
      supplierProductId: selectedItem.supplierProductId,
      quantity: 1,
      supplierQuantity: 1,
      isNew: 1,
      isAddedBySupplier: 1,
    });
  }
  // Category autocomplete section
  filterFieldSupplierProductNameDisplayFn(
    _supplierProduct: AutoCompleteSupplierProduct
  ) {
    return _supplierProduct ? `${_supplierProduct.partNo}` : undefined;
  }

  getSupplierProductFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    console.log('Search Parameter:', pageMeta.serachParam);
    const response =
      this.SettingsService.getAllAutocompleteSupplierProductByFliterKeyValueAndSupplierIdByRfqToken(
        pageMeta.serachParam,
        this.userId,
        pageMeta
      );
    console.log('Response Category', response);
    return response;
  }

  getPartNumberControl(index: number): FormControl {
    const rows = this.lineItemtableForm.get('rows') as FormArray;
    const row = rows.at(index) as FormGroup;
    return row.get('addedLineItempartNumber') as FormControl;
  }

  async getTaxDetails() {
    this.fullLoaderService.showLoader();
    let data = {
      supplierId: this.userId,
    };
    const response = await this.SettingsService.getTaxDetailsBySupplierByRfqToken(data);
    this.taxStatusData = response.rows;
    this.fullLoaderService.hideLoader();
  }

  async fetchDefaultCurrency() {
    const transactionSetupdata =
      await this.SettingsService.fetchSupplierSetupByRfqToken(
        'TransactionSetup'
      );

    if (transactionSetupdata.length > 0) {
      this.secondFormGroup.patchValue({
        supplierCurrency: {
          id: transactionSetupdata[0].default_currency,
          currencyName: transactionSetupdata[0].currencyName,
          currencyCode: transactionSetupdata[0].currencyCode,
          currencySymbol: transactionSetupdata[0].currencySymbol,
        },
      });
    }
  }

  async togglePreview(value: boolean, section: string, docs?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (docs) {
      if (section == 'single') {
        this.previewDocs.push(docs);
      } else if (section == 'multiple') {
        this.previewDocs = docs;
      }
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDocs.length) %
      this.previewDocs.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }

  // Optional: You can implement logic to show more info when the info icon is clicked.
  showInfo(): void {
    // Logic to show additional info (e.g., a dialog, alert, or modal)
    console.log('Info icon clicked - show additional info!');
  }

  onTaxProfileChange(event: MatSelectChange) {
    const selectedTaxId = event.value;

    const selectedTaxProfile = this.taxStatusData.find(
      (item) => item.taxId === Number(selectedTaxId)
    );

    if (selectedTaxProfile) {
      const taxType = selectedTaxProfile.taxType;
      this.secondFormGroup.patchValue({
        quoteLineItemTaxType: taxType,
      });
      this.quoteLineItemTaxType = taxType;
      console.log('Selected Tax Type:', taxType);
      this.isTotalsCardOpen = false;
    } else {
      console.log('Tax profile not found for selected ID:', selectedTaxId);
    }

    this.calculateCostSummary();
  }

  applyConversionToUnitCost(
    row: any,
    supplierCurrency: string,
    baseCurrency: string,
    supplierAmount: number
  ) {
    const rates = this.exchangeRatesCache[baseCurrency]; // Fetch the cached exchange rates for the buyer currency

    // Check if the exchange rate for the supplier currency exists in the buyer currency's rates
    if (rates && rates[supplierCurrency]) {
      const conversionRate = rates[supplierCurrency]; // Get the conversion rate for the supplier currency
      const convertedAmount = (supplierAmount * conversionRate).toFixed(2); // Convert the supplier amount to buyer currency and format to 2 decimal places

      // Set the converted value in the 'buyerAmount' form control for the row
      row.get('requestedUnitCost')?.setValue(convertedAmount);
      console.log(
        `Converted amount for ${supplierCurrency} to ${baseCurrency}: ${convertedAmount}`
      );
    } else {
      // If conversion rate is not available, show an error and set the buyer amount to 'N/A'
      this.snack.open('Conversion rate not available', 'Close', {
        duration: 4000,
      });
      row.get('requestedUnitCost')?.setValue(0);
    }
  }

  applyConversionToTotalCost(
    row: any,
    supplierCurrency: string,
    baseCurrency: string,
    supplierAmount: number
  ) {
    const rates = this.exchangeRatesCache[baseCurrency]; // Fetch the cached exchange rates for the buyer currency

    // Check if the exchange rate for the supplier currency exists in the buyer currency's rates
    if (rates && rates[supplierCurrency]) {
      const conversionRate = rates[supplierCurrency]; // Get the conversion rate for the supplier currency
      const convertedAmount = (supplierAmount * conversionRate).toFixed(2); // Convert the supplier amount to buyer currency and format to 2 decimal places

      // Set the converted value in the 'buyerAmount' form control for the row
      row.get('requestedTotalCost')?.setValue(convertedAmount);
      console.log(
        `Converted amount for ${supplierCurrency} to ${baseCurrency}: ${convertedAmount}`
      );
    } else {
      // If conversion rate is not available, show an error and set the buyer amount to 'N/A'
      this.snack.open('Conversion rate not available', 'Close', {
        duration: 4000,
      });
      row.get('requestedTotalCost')?.setValue(0);
    }
  }

  // ─── Tax Profile Sidebar Methods ───

  loadCountryList() {
    this.SettingsService.getAllCountriesByFliterKeyValue().subscribe({
      next: (res: any) => {
        this.countryList = Array.isArray(res?.rows) ? res.rows : [];
        this.filteredCountryList = [...this.countryList];
      },
      error: () => {
        this.countryList = [];
        this.filteredCountryList = [];
      },
    });
  }

  filterCountries(searchText: string): void {
    if (!searchText) {
      this.filteredCountryList = [...this.countryList];
    } else {
      const regex = new RegExp(searchText, 'i');
      this.filteredCountryList = this.countryList.filter((c: any) => regex.test(c.name));
    }
  }

  countryDisplayFn(country: any): string {
    return country ? country.name : '';
  }

  toggleTaxSidebar(): void {
    if (this.showTaxSideBar) {
      this.taxForm.reset();
      this.countryRegions = [];
      this.filteredCountryList = [...this.countryList];
    }
    this.showTaxSideBar = !this.showTaxSideBar;
  }

  onTaxCountrySelected(country: any): void {
    this.taxForm.get('region')?.reset();
    this.taxForm.get('regionName')?.reset();
    this._selectedCountryCode = country?.code || '';
    this.SettingsService.getAllRegionsByFliterKeyValueByRfqToken(this._selectedCountryCode).subscribe(data => {
      this.countryRegions = data.rows || [];
    });
  }

  onTaxRegionSelected(selectedIso: string): void {
    const selectedRegion = this.countryRegions.find((region: any) => region.iso === selectedIso);
    if (selectedRegion) {
      this.taxForm.patchValue({ regionName: selectedRegion.name });
    }
  }

  allowOnlyDecimalTax(event: KeyboardEvent): void {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    const input = event.target as HTMLInputElement;

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }

    // Prevent multiple dots
    if (event.key === '.' && input.value.includes('.')) {
      event.preventDefault();
    }
  }

  async onGstAttachmentChange(files: NgxFileDropEntry[]) {
    try {
      if (files.length > 1) {
        this.snack.open('Please drop only one file at a time.', 'OK', { duration: 1000 });
        return;
      }
      const fileEntry = files[0].fileEntry as FileSystemFileEntry;
      await new Promise((res, rej) => {
        fileEntry.file(file => {
          this.gstCertificateFile = file;
          res(file);
        });
      });
    } catch (error: any) {
      this.snack.open(error, 'OK', { duration: 1000 });
    }
  }

  async uploadTaxCertificate(file: File, formData: any) {
    this.fullLoaderService.showLoader('Uploading Certificate...');
    if (file != null) {
      let fileExt = file.name.slice(
        ((file.name.lastIndexOf('.') - 1) >>> 0) + 2
      );

      let fileName = uuidv4() + '.' + fileExt.toLowerCase();
      let s3Location = `gstCertificate/${fileName}`;

      let _s3Params = {
        fileKey: s3Location,
        fileContentType: (<File>file).type,
      };

      await this.awsSdkService
        .getSignedUrlPromise(_s3Params)
        .then((_fileUploadLink) => {
          if (_fileUploadLink) {
            this.webApiService
              .putRequestExternalApi(_fileUploadLink, file)
              .then(async (_fileUploadData: any) => {
                let filePath =
                  this.awsSdkService.extractS3LocationFromUrl(_fileUploadLink);

                await this.addNewTaxProfile(formData, filePath);

                this.taxForm.patchValue({
                  gstCertificateAttachment: filePath,
                });
              })
              .catch((_httpErrorResponse: HttpErrorResponse) => {
                console.log('Error while uploading file==>', _httpErrorResponse);
                this.fullLoaderService.hideLoader();
                this.snack.open('Error uploading certificate', 'OK', { duration: 3000 });
              });
          }
        })
        .catch((error) => {
          console.log('Error getting presigned URL==>', error);
          this.fullLoaderService.hideLoader();
        });
    }
  }

  async addNewTaxProfile(formdata: any, filePath: string) {
    try {
      const data = {
        taxId: formdata.taxId,
        nameofTaxProfile: formdata.nameOfTaxProfile,
        taxType: formdata.taxType,
        taxNumber: formdata.taxNumber,
        taxPercentage: formdata.taxPercentage,
        country: formdata.country?.name,
        region: { name: formdata.regionName, iso: formdata.region },
        supplierId: this.userId,
        s3FilePath: filePath,
      };

      const response = await this.SettingsService.addTaxDetailsBySupplierByRfqToken(data);
      this.gstCertificateFile = undefined as any;

      const message = response?.message ||
        (response?.success ? 'Tax Details Added!!' : 'Error in Adding Tax Details!!');
      this.snack.open(message, 'OK', { duration: 3000 });

      await this.getTaxDetails();
    } catch (_httpErrorResponse: any) {
      console.log(_httpErrorResponse);
      this.fullLoaderService.hideLoader();
      if (_httpErrorResponse instanceof HttpErrorResponse) {
        this.snack.open(`${_httpErrorResponse.error.errors[0].message}`, 'OK', { duration: 3000 });
      } else {
        this.snack.open(`${_httpErrorResponse}`, 'OK', { duration: 3000 });
      }
    }
  }

  async saveTaxForm() {
    if (this.taxForm.valid) {
      const formData = { ...this.taxForm.value };
      const certFile = this.gstCertificateFile;
      this.toggleTaxSidebar();
      if (certFile) {
        await this.uploadTaxCertificate(certFile, formData);
      } else {
        this.fullLoaderService.showLoader('Saving Tax Profile...');
        await this.addNewTaxProfile(formData, formData.s3FilePath || '');
      }
    }
  }
}

// getPartNumberControl(index: number): FormControl {
//   const rows = this.lineItemtableForm.get('rows') as FormArray;
//   const row = rows.at(index) as FormGroup;
//   // Ensure that the control handles both numbers and strings
//   return row?.get('addedLineItempartNumber') as FormControl ?? new FormControl('');
// }
